import { useStore } from 'hooks/useStore';
import { observer } from 'mobx-react';
import { useEffect } from 'react';

const FeatureFlagInitializer = observer(() => {
  const { UserStore, FeatureFlagStore } = useStore();

  useEffect(() => {
    if (UserStore.isAuthenticated && !FeatureFlagStore.isLoaded) {
      FeatureFlagStore.loadFlags();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [UserStore.isAuthenticated, FeatureFlagStore.isLoaded]);

  useEffect(() => {
    const handleFocus = () => {
      if (UserStore.isAuthenticated) {
        FeatureFlagStore.loadFlags();
      }
    };

    window.addEventListener('focus', handleFocus);
    return () => window.removeEventListener('focus', handleFocus);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [UserStore.isAuthenticated]);

  return null;
});

export default FeatureFlagInitializer;
